import React from 'react';
import { TextField, TextFieldProps, FormLabel } from '@mui/material';
import pallet from '../../layouts/pallet';

interface TopLabelTextFieldProps extends Omit<TextFieldProps, 'label'> {
  label?: string; 
  hasTopLabel?: boolean;
  required?: boolean;
}

const TopLabelTextField: React.FC<TopLabelTextFieldProps> = ({
  label,
  hasTopLabel = false,
  required,
  InputLabelProps,  
  ...textFieldProps
}) => {
  return (
    <>
      {hasTopLabel && (
        <FormLabel
          required={required}
          sx={{
            mb: 1,
            color: pallet.textLabel,
            fontSize: 14,
            fontWeight: 600
          }}
        >
          {label}
        </FormLabel>
      )}
      <TextField
        {...(hasTopLabel ? { label: undefined } : { label })}
        {...textFieldProps}
        InputLabelProps={{
          ...InputLabelProps, 
          shrink: hasTopLabel || InputLabelProps?.shrink
        }}
      />
    </>
  );
};

export default TopLabelTextField;
